import { createRootRoute, Navigate } from "@tanstack/react-router"

import { routes } from "#/shared/constants"

import App from "../App"

// Object with redirects for the URLs that were removed.
// Key is the matching route and value is the route to be redirected to.
// As some users may be used to the previous URLs we should allow them to
// enter them and redirect them to the correct URL then
const DEPRECATED_URL_REDIRECTS = {
  "/landing": routes.LANDING,
  "/home": routes.OVERVIEW,
}

export function NotFoundRoute() {
  const { location } = window

  const redirectTo =
    // @ts-expect-error we are passing non-defined route
    DEPRECATED_URL_REDIRECTS[location.pathname] ?? routes.LANDING

  return <Navigate to={redirectTo} />
}

export const Route = createRootRoute({
  component: () => <App />,
})
